import AnnouncementsDataTable from "../../../components/dataTable/tables/AnnouncementsDataTable";

function AnnouncementsPageView() {
  return <AnnouncementsDataTable />;
}

export default AnnouncementsPageView;
